var _path, _polygon, _polygon2, _polygon3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVectorLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-2"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 382.4,
    width: 500,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 416.78,
    y: 398.49,
    width: 33.12,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 322.53,
    y: 401.21,
    width: 8.69,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 396.59,
    y: 389.21,
    width: 19.19,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.46,
    y: 390.89,
    width: 43.19,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 104.56,
    y: 390.89,
    width: 6.33,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.47,
    y: 395.11,
    width: 93.68,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237,337.8H43.91a5.71,5.71,0,0,1-5.7-5.71V60.66A5.71,5.71,0,0,1,43.91,55H237a5.71,5.71,0,0,1,5.71,5.71V332.09A5.71,5.71,0,0,1,237,337.8ZM43.91,55.2a5.46,5.46,0,0,0-5.45,5.46V332.09a5.46,5.46,0,0,0,5.45,5.46H237a5.47,5.47,0,0,0,5.46-5.46V60.66A5.47,5.47,0,0,0,237,55.2Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.31,337.8H260.21a5.72,5.72,0,0,1-5.71-5.71V60.66A5.72,5.72,0,0,1,260.21,55h193.1A5.71,5.71,0,0,1,459,60.66V332.09A5.71,5.71,0,0,1,453.31,337.8ZM260.21,55.2a5.47,5.47,0,0,0-5.46,5.46V332.09a5.47,5.47,0,0,0,5.46,5.46h193.1a5.47,5.47,0,0,0,5.46-5.46V60.66a5.47,5.47,0,0,0-5.46-5.46Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.54,282.45H436.69a8.24,8.24,0,0,1-7.88,8.23c-12.91.59-32.78,2.63-39.07,9.77-11.75,13.32-10.61,60.1,3.46,70.93,4.4,3.4,17.26,10.14,17.26,10.14H342.77s12-6.88,16.19-10.14c14-10.92,14.39-57.67,2.59-70.93-6.05-6.8-24.67-9-37.16-9.69A8.31,8.31,0,0,1,316.54,282.45Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.8,291.12c-12.2,1-26.82,3.39-32.06,9.33a23.74,23.74,0,0,0-4,6.88H365.59a24.5,24.5,0,0,0-4-6.88c-5.26-5.91-20-8.34-32-9.33Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "367.72 282.51 369.36 263.84 345.67 263.84 344.04 282.51 367.72 282.51",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "367.72 282.51 369.36 263.84 370.63 263.84 369 282.51 367.72 282.51",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "365.47 280.61 366.77 265.74 347.92 265.74 346.62 280.61 365.47 280.61",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "364.03 279.38 365.11 266.97 349.37 266.97 348.28 279.38 364.03 279.38",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "375.4 282.45 399.19 282.45 396.55 252.28 372.76 252.28 375.4 282.45",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "375.4 282.45 374.27 282.45 371.63 252.28 372.76 252.28 375.4 282.45",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "377.56 279.38 396.5 279.38 394.4 255.36 375.46 255.36 377.56 279.38",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "378.94 277.4 394.77 277.4 393.01 257.34 377.19 257.34 378.94 277.4",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.94,266.36h0a2.75,2.75,0,0,1-3.9,0h0a2.76,2.76,0,0,1,0-3.89h0a2.77,2.77,0,0,1,3.9,0h0A2.76,2.76,0,0,1,386.94,266.36Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.77,269.74h0a2,2,0,0,1,2.85,0h0a2,2,0,0,1-1.42,3.44h0A2,2,0,0,1,385.77,269.74Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 81.73,
    y: 123.98,
    width: 112.19,
    height: 124.08,
    transform: "translate(275.64 372.04) rotate(180)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 78.15,
    y: 123.98,
    width: 116.36,
    height: 124.08,
    transform: "translate(272.65 372.04) rotate(180)",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.07,
    y: 127.94,
    width: 106.7,
    height: 114.42,
    transform: "translate(272.84 370.29) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.07,
    y: 127.94,
    width: 3.09,
    height: 114.42,
    transform: "translate(169.22 370.29) rotate(180)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 136.39,
    y: 159.65,
    width: 3.09,
    height: 104.22,
    transform: "translate(-73.83 349.69) rotate(-90)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.07,
    y: 205.04,
    width: 108.36,
    height: 5.18,
    transform: "translate(274.49 415.25) rotate(180)",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.39,145.22s1-6.6-3.81-10.83-4.39-6.75-3-7.08,2.64,3.91,4.76,5.07c0,0,.07-6-2.08-8.25s-3.28-7.94-1.23-8,2.25,3.4,2.68,5.88,2.7,6,2.7,6,.44-5.4,1.83-7.62-2.31-7.3-.88-9.52,4,2,3.75,6.77-3.38,9.84-2.64,14.81c0,0,1.4-3.49,2.65-3.81s2.53-2.62,3.37-3.48,1.91,2.11,0,4.86-6.76,10.11-6,16.05Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.51,142.22l-1.58,9.89a5,5,0,0,0,5,5.82h1.68a5,5,0,0,0,5-5.82L384,142.22Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 287.94,
    y: 154.28,
    width: 111.4,
    height: 5.72,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 293.07,
    y: 133.18,
    width: 4.91,
    height: 21.1,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 316.8,
    y: 133.18,
    width: 4.91,
    height: 21.1,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 345.57,
    y: 132.92,
    width: 4.91,
    height: 21.1,
    transform: "translate(-19.31 61.19) rotate(-9.78)",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 299.15,
    y: 135.96,
    width: 4.91,
    height: 18.32,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 310.43,
    y: 135.96,
    width: 4.91,
    height: 18.32,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 338.91,
    y: 135.96,
    width: 4.91,
    height: 18.32,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 325.29,
    y: 135.65,
    width: 4.91,
    height: 18.32,
    transform: "translate(-23.61 74.53) rotate(-12.53)",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 305.85,
    y: 132.13,
    width: 2.45,
    height: 22.15,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 335.04,
    y: 132.13,
    width: 2.45,
    height: 22.15,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 287.94,
    y: 197.01,
    width: 111.4,
    height: 5.72,
    transform: "translate(687.29 399.74) rotate(180)",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 389.31,
    y: 175.91,
    width: 4.91,
    height: 21.1,
    transform: "translate(783.53 372.92) rotate(180)",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 365.58,
    y: 175.91,
    width: 4.91,
    height: 21.1,
    transform: "translate(736.07 372.92) rotate(180)",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 336.81,
    y: 175.65,
    width: 4.91,
    height: 21.1,
    transform: "translate(641.98 427.3) rotate(-170.22)",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 383.23,
    y: 178.69,
    width: 4.91,
    height: 18.32,
    transform: "translate(771.37 375.7) rotate(180)",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 371.95,
    y: 178.69,
    width: 4.91,
    height: 18.32,
    transform: "translate(748.81 375.7) rotate(180)",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 343.48,
    y: 178.69,
    width: 4.91,
    height: 18.32,
    transform: "translate(691.86 375.7) rotate(180)",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 357.09,
    y: 178.38,
    width: 4.91,
    height: 18.32,
    transform: "translate(669.85 448.59) rotate(-167.47)",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 378.99,
    y: 174.86,
    width: 2.45,
    height: 22.15,
    transform: "translate(760.43 371.87) rotate(180)",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 349.79,
    y: 174.86,
    width: 2.45,
    height: 22.15,
    transform: "translate(702.04 371.87) rotate(180)",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 298.63,
    y: 180.31,
    width: 23.91,
    height: 16.51,
    transform: "translate(621.18 377.13) rotate(180)",
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-2"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--path--inject-2",
    cx: 250,
    cy: 416.24,
    rx: 193.89,
    ry: 11.32,
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M332.47,391.23s-5-10.8.7-21.46,7.3-13.16,3.7-15.34S331.6,363,331.6,363a24,24,0,0,1-.53-15.07c2.51-7.71,4.09-20.26.66-21.61s-.65,15.66-3.63,21.46a49.82,49.82,0,0,1-2.91-12.64c-.41-6.19.23-16.08-2.48-18.61s-4.44-.79-1.78,12.88a142.9,142.9,0,0,1,2.64,24.76s-5.87-17.92-9.82-18.44-3.94,5.28-.56,10.31,9.89,14.05,10.95,18.69c0,0-6.45-13.48-12.25-9.35s5.05,12.28,9.89,15.22,8.2,21.39,8.2,21.39Z",
    style: {
      fill: "#007D87"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.47,391.23s-5-10.8.7-21.46,7.3-13.16,3.7-15.34S331.6,363,331.6,363a24,24,0,0,1-.53-15.07c2.51-7.71,4.09-20.26.66-21.61s-.65,15.66-3.63,21.46a49.82,49.82,0,0,1-2.91-12.64c-.41-6.19.23-16.08-2.48-18.61s-4.44-.79-1.78,12.88a142.9,142.9,0,0,1,2.64,24.76s-5.87-17.92-9.82-18.44-3.94,5.28-.56,10.31,9.89,14.05,10.95,18.69c0,0-6.45-13.48-12.25-9.35s5.05,12.28,9.89,15.22,8.2,21.39,8.2,21.39Z",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.56,395.66s4.82-10.88-1-21.44-7.46-13.06-3.88-15.29,5.36,8.44,5.36,8.44a24,24,0,0,0,.35-15.08c-2.6-7.66-4.33-20.19-.91-21.59s.84,15.65,3.88,21.4a49.65,49.65,0,0,0,2.76-12.69c.34-6.19-.42-16.07,2.26-18.64s4.43-.85,1.93,12.85a142.37,142.37,0,0,0-2.34,24.8s5.66-18,9.6-18.58,4,5.22.68,10.3-9.71,14.2-10.73,18.85c0,0,6.29-13.58,12.14-9.53s-4.9,12.35-9.7,15.37-7.94,21.51-7.94,21.51Z",
    style: {
      fill: "#007D87"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "350.8 387.91 310.96 387.91 314.19 416.42 347.58 416.42 350.8 387.91",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Window--inject-2"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 216.01,
    y: 104.4,
    width: 215.52,
    height: 191.98,
    rx: 2.48,
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 207.86,
    y: 100.85,
    width: 215.52,
    height: 191.98,
    rx: 2.48,
    style: {
      fill: "#007D87"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.86,118V290.36a2.3,2.3,0,0,0,2,2.48H421.32a2.3,2.3,0,0,0,2.06-2.48V118Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 210.41,
    y: 128.11,
    width: 210.41,
    height: 152.27,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 416.34,
    cy: 108.9,
    rx: 3.16,
    ry: 3.81,
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 405.99,
    cy: 108.9,
    rx: 3.16,
    ry: 3.81,
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.79,108.9c0,2.1-1.41,3.8-3.16,3.8s-3.15-1.7-3.15-3.8,1.41-3.81,3.15-3.81S398.79,106.79,398.79,108.9Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "255.24 145.89 255.24 185.16 245.14 197.34 222.77 197.34 222.77 145.89 255.24 145.89",
    style: {
      fill: "#007D87"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "255.24 145.89 255.24 185.16 245.14 197.34 222.77 197.34 222.77 145.89 255.24 145.89",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "255.24 185.16 245.14 197.34 245.14 185.16 255.24 185.16",
    style: {
      fill: "#007D87",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 227.81,
    y: 153.31,
    width: 22.4,
    height: 1.47,
    style: {
      fill: "#007D87",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 227.81,
    y: 158.89,
    width: 22.4,
    height: 1.47,
    style: {
      fill: "#007D87",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 227.81,
    y: 164.48,
    width: 22.4,
    height: 1.48,
    style: {
      fill: "#007D87",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 227.81,
    y: 170.07,
    width: 22.4,
    height: 1.47,
    style: {
      fill: "#007D87",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 227.81,
    y: 175.66,
    width: 16.61,
    height: 1.48,
    style: {
      fill: "#007D87",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "306.74 145.89 306.74 185.16 296.64 197.34 274.27 197.34 274.27 145.89 306.74 145.89",
    style: {
      fill: "#007D87"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "306.74 145.89 306.74 185.16 296.64 197.34 274.27 197.34 274.27 145.89 306.74 145.89",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "306.74 185.16 296.64 197.34 296.64 185.16 306.74 185.16",
    style: {
      fill: "#007D87",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 279.3,
    y: 153.31,
    width: 22.4,
    height: 1.47,
    style: {
      fill: "#007D87",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 279.3,
    y: 158.89,
    width: 22.4,
    height: 1.47,
    style: {
      fill: "#007D87",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 279.3,
    y: 164.48,
    width: 22.4,
    height: 1.48,
    style: {
      fill: "#007D87",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 279.3,
    y: 170.07,
    width: 22.4,
    height: 1.47,
    style: {
      fill: "#007D87",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 279.3,
    y: 175.66,
    width: 16.61,
    height: 1.48,
    style: {
      fill: "#007D87",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "358.24 145.89 358.24 185.16 348.14 197.34 325.77 197.34 325.77 145.89 358.24 145.89",
    style: {
      fill: "#007D87"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "358.24 145.89 358.24 185.16 348.14 197.34 325.77 197.34 325.77 145.89 358.24 145.89",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "358.24 185.16 348.14 197.34 348.14 185.16 358.24 185.16",
    style: {
      fill: "#007D87",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 330.8,
    y: 153.31,
    width: 22.4,
    height: 1.47,
    style: {
      fill: "#007D87",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 330.8,
    y: 158.89,
    width: 22.4,
    height: 1.47,
    style: {
      fill: "#007D87",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 330.8,
    y: 164.48,
    width: 22.4,
    height: 1.48,
    style: {
      fill: "#007D87",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 330.8,
    y: 170.07,
    width: 22.4,
    height: 1.47,
    style: {
      fill: "#007D87",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 330.8,
    y: 175.66,
    width: 16.61,
    height: 1.48,
    style: {
      fill: "#007D87",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "409.74 145.89 409.74 185.16 399.63 197.34 377.27 197.34 377.27 145.89 409.74 145.89",
    style: {
      fill: "#007D87"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "409.74 145.89 409.74 185.16 399.63 197.34 377.27 197.34 377.27 145.89 409.74 145.89",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "409.74 185.16 399.63 197.34 399.63 185.16 409.74 185.16",
    style: {
      fill: "#007D87",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 382.3,
    y: 153.31,
    width: 22.4,
    height: 1.47,
    style: {
      fill: "#007D87",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 382.3,
    y: 158.89,
    width: 22.4,
    height: 1.47,
    style: {
      fill: "#007D87",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 382.3,
    y: 164.48,
    width: 22.4,
    height: 1.48,
    style: {
      fill: "#007D87",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 382.3,
    y: 170.07,
    width: 22.4,
    height: 1.47,
    style: {
      fill: "#007D87",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 382.3,
    y: 175.66,
    width: 16.61,
    height: 1.48,
    style: {
      fill: "#007D87",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "255.24 213.89 255.24 253.16 245.14 265.34 222.77 265.34 222.77 213.89 255.24 213.89",
    style: {
      fill: "#007D87"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "255.24 213.89 255.24 253.16 245.14 265.34 222.77 265.34 222.77 213.89 255.24 213.89",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "255.24 253.16 245.14 265.34 245.14 253.16 255.24 253.16",
    style: {
      fill: "#007D87",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 227.81,
    y: 221.31,
    width: 22.4,
    height: 1.47,
    style: {
      fill: "#007D87",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 227.81,
    y: 226.89,
    width: 22.4,
    height: 1.47,
    style: {
      fill: "#007D87",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 227.81,
    y: 232.48,
    width: 22.4,
    height: 1.48,
    style: {
      fill: "#007D87",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 227.81,
    y: 238.07,
    width: 22.4,
    height: 1.48,
    style: {
      fill: "#007D87",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 227.81,
    y: 243.66,
    width: 16.61,
    height: 1.47,
    style: {
      fill: "#007D87",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "306.74 213.89 306.74 253.16 296.64 265.34 274.27 265.34 274.27 213.89 306.74 213.89",
    style: {
      fill: "#007D87"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "306.74 213.89 306.74 253.16 296.64 265.34 274.27 265.34 274.27 213.89 306.74 213.89",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "306.74 253.16 296.64 265.34 296.64 253.16 306.74 253.16",
    style: {
      fill: "#007D87",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 279.3,
    y: 221.31,
    width: 22.4,
    height: 1.47,
    style: {
      fill: "#007D87",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 279.3,
    y: 226.89,
    width: 22.4,
    height: 1.47,
    style: {
      fill: "#007D87",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 279.3,
    y: 232.48,
    width: 22.4,
    height: 1.48,
    style: {
      fill: "#007D87",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 279.3,
    y: 238.07,
    width: 22.4,
    height: 1.48,
    style: {
      fill: "#007D87",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 279.3,
    y: 243.66,
    width: 16.61,
    height: 1.47,
    style: {
      fill: "#007D87",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "358.24 213.89 358.24 253.16 348.14 265.34 325.77 265.34 325.77 213.89 358.24 213.89",
    style: {
      fill: "#007D87"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "358.24 213.89 358.24 253.16 348.14 265.34 325.77 265.34 325.77 213.89 358.24 213.89",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "358.24 253.16 348.14 265.34 348.14 253.16 358.24 253.16",
    style: {
      fill: "#007D87",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 330.8,
    y: 221.31,
    width: 22.4,
    height: 1.47,
    style: {
      fill: "#007D87",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 330.8,
    y: 226.89,
    width: 22.4,
    height: 1.47,
    style: {
      fill: "#007D87",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 330.8,
    y: 232.48,
    width: 22.4,
    height: 1.48,
    style: {
      fill: "#007D87",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 330.8,
    y: 238.07,
    width: 22.4,
    height: 1.48,
    style: {
      fill: "#007D87",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 330.8,
    y: 243.66,
    width: 16.61,
    height: 1.47,
    style: {
      fill: "#007D87",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "409.74 213.89 409.74 253.16 399.63 265.34 377.27 265.34 377.27 213.89 409.74 213.89",
    style: {
      fill: "#007D87"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "409.74 213.89 409.74 253.16 399.63 265.34 377.27 265.34 377.27 213.89 409.74 213.89",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "409.74 253.16 399.63 265.34 399.63 253.16 409.74 253.16",
    style: {
      fill: "#007D87",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 382.3,
    y: 221.31,
    width: 22.4,
    height: 1.47,
    style: {
      fill: "#007D87",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 382.3,
    y: 226.89,
    width: 22.4,
    height: 1.47,
    style: {
      fill: "#007D87",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 382.3,
    y: 232.48,
    width: 22.4,
    height: 1.48,
    style: {
      fill: "#007D87",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 382.3,
    y: 238.07,
    width: 22.4,
    height: 1.48,
    style: {
      fill: "#007D87",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 382.3,
    y: 243.66,
    width: 16.61,
    height: 1.47,
    style: {
      fill: "#007D87",
      opacity: 0.30000000000000004
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Padlock--inject-2"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 273.78,
    y: 181.35,
    width: 60.53,
    height: 47.54,
    rx: 4.35,
    style: {
      opacity: 0.1,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1,
      isolation: "isolate"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M326.25,179.14h-6v-6.49a15.46,15.46,0,1,0-30.92,0v6.49h-6v-6.49a21.46,21.46,0,1,1,42.92,0Z"
  }))), /*#__PURE__*/React.createElement("rect", {
    x: 248.78,
    y: 179.35,
    width: 60.53,
    height: 47.54,
    rx: 4.35,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 248.78,
    y: 179.35,
    width: 49.58,
    height: 47.54,
    rx: 4.35,
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.61,197.19c0-3.28-2-5.94-4.46-5.94s-4.45,2.66-4.45,5.94a6.16,6.16,0,0,0,2.79,5.5l-.83,12.4h5l-.82-12.4A6.18,6.18,0,0,0,276.61,197.19Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.25,177.14h-6v-6.49a15.46,15.46,0,1,0-30.92,0v6.49h-6v-6.49a21.46,21.46,0,1,1,42.92,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M301.25,177.14h-6v-6.49a15.46,15.46,0,1,0-30.92,0v6.49h-6v-6.49a21.46,21.46,0,1,1,42.92,0Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M301.25,170.65v6.49h-4.07v-7.23a19.6,19.6,0,0,0-19.61-19.6,19.07,19.07,0,0,0-11,3.45,21.44,21.44,0,0,1,34.67,16.89Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Desk--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M216.46,285.63H192.22v-.93h5.47a1.58,1.58,0,0,0,1.54-1.3l2.45-14.58.48-2.87h8.3l7.43,17.52A1.55,1.55,0,0,1,216.46,285.63Z",
    style: {
      fill: "#007D87"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.46,285.63H192.22v-.93h5.47a1.58,1.58,0,0,0,1.54-1.3l2.45-14.58.48-2.87h8.3l7.43,17.52A1.55,1.55,0,0,1,216.46,285.63Z",
    style: {
      fill: "#fff",
      opacity: 0.4,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.49,284.7h-18.8a1.58,1.58,0,0,0,1.54-1.3l2.45-14.58h8.7L217,283.93A.55.55,0,0,1,216.49,284.7Z",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.49,271.32H181a.71.71,0,0,1-.72-.88L187.18,234a1.12,1.12,0,0,1,1-.88h48.48a.7.7,0,0,1,.71.88l-6.88,36.43A1.12,1.12,0,0,1,229.49,271.32Z",
    style: {
      fill: "#007D87"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.49,271.32H181a.71.71,0,0,1-.72-.88L187.18,234a1.12,1.12,0,0,1,1-.88h48.48a.7.7,0,0,1,.71.88l-6.88,36.43A1.12,1.12,0,0,1,229.49,271.32Z",
    style: {
      fill: "#fff",
      opacity: 0.4,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.49,271.32H180a.71.71,0,0,1-.72-.88L186.18,234a1.12,1.12,0,0,1,1-.88h48.48a.7.7,0,0,1,.71.88l-6.88,36.43A1.12,1.12,0,0,1,228.49,271.32Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "227.85 269.08 181.49 269.08 187.87 235.37 234.22 235.37 227.85 269.08",
    style: {
      fill: "#007D87"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.05,285.63v-1.14l18.66-3.77h36.51a2.45,2.45,0,0,1,2.45,2.45h0a2.46,2.46,0,0,1-2.45,2.46Z",
    style: {
      fill: "#007D87"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.67,283.18a2.45,2.45,0,0,1-.71,1.73,2.48,2.48,0,0,1-1.74.72H147.05V284.5l18.67-3.78h36.5A2.45,2.45,0,0,1,204.67,283.18Z",
    style: {
      fill: "#fff",
      opacity: 0.4,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.67,283.18a2.45,2.45,0,0,1-.71,1.73,2.48,2.48,0,0,1-1.74.72H180.05V284.5l18.67-3.78h3.5A2.45,2.45,0,0,1,204.67,283.18Z",
    style: {
      fill: "#fff",
      opacity: 0.4,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "218.01 416.42 223.01 416.42 231.98 291.48 225.35 291.48 218.01 416.42",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "218.01 416.42 223.01 416.42 231.54 297.68 231.98 291.68 225.35 291.68 225 297.68 218.01 416.42",
    style: {
      fill: "#fff",
      opacity: 0.1,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "225 297.38 231.54 297.38 231.98 291.68 225.35 291.68 225 297.38",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "181.36 416.42 186.35 416.42 187.17 291.48 180.54 291.48 181.36 416.42",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "180.54 291.68 180.67 311.84 181.35 416.42 186.35 416.42 187.03 311.84 187.16 291.68 180.54 291.68",
    style: {
      fill: "#fff",
      opacity: 0.1,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "180.54 291.68 180.67 312.06 187.03 312.06 187.16 291.68 180.54 291.68",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "128.33 416.42 133.32 416.42 142.3 291.48 135.67 291.48 128.33 416.42",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "128.32 416.42 133.32 416.42 141.86 297.68 142.3 291.68 135.67 291.68 135.31 297.68 128.32 416.42",
    style: {
      fill: "#fff",
      opacity: 0.1,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "135.31 297.38 141.86 297.38 142.3 291.68 135.67 291.68 135.31 297.38",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "275.15 416.42 280.14 416.42 272.8 291.48 266.18 291.48 275.15 416.42",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "266.18 291.68 266.62 297.68 275.15 416.42 280.14 416.42 273.16 297.68 272.8 291.68 266.18 291.68",
    style: {
      fill: "#fff",
      opacity: 0.1,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "272.8 291.68 266.18 291.68 266.62 297.38 273.16 297.38 272.8 291.68",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.58,288.35H275.89a2.16,2.16,0,0,1,2.16,2.16v4.1a0,0,0,0,1,0,0H130.42a0,0,0,0,1,0,0v-4.1A2.16,2.16,0,0,1,132.58,288.35Z",
    transform: "translate(408.47 582.95) rotate(180)",
    style: {
      fill: "#007D87"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.58,288.35H275.89a2.16,2.16,0,0,1,2.16,2.16v4.1a0,0,0,0,1,0,0H130.42a0,0,0,0,1,0,0v-4.1A2.16,2.16,0,0,1,132.58,288.35Z",
    transform: "translate(408.47 582.95) rotate(180)",
    style: {
      fill: "#fff",
      opacity: 0.4,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 130.42,
    y: 288.35,
    width: 147.64,
    height: 3.13,
    transform: "translate(408.47 579.82) rotate(180)",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.32,289.16H281.15a1.76,1.76,0,0,0,1.76-1.76h0a1.76,1.76,0,0,0-1.76-1.76H127.32a1.76,1.76,0,0,0-1.76,1.76h0A1.76,1.76,0,0,0,127.32,289.16Z",
    style: {
      fill: "#007D87"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.32,289.16H281.15a1.76,1.76,0,0,0,1.76-1.76h0a1.76,1.76,0,0,0-1.76-1.76H127.32a1.76,1.76,0,0,0-1.76,1.76h0A1.76,1.76,0,0,0,127.32,289.16Z",
    style: {
      fill: "#fff",
      opacity: 0.4,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.44,254.26a1.5,1.5,0,0,1-1.46-1.78l.62-3.19a1.93,1.93,0,0,1,1.88-1.55h26a1.47,1.47,0,0,1,1.15.55,1.44,1.44,0,0,1,.31,1.23l-.62,3.19a1.91,1.91,0,0,1-1.87,1.55Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.45,253.76h-26a1,1,0,0,1-1-1.18l.63-3.2a1.4,1.4,0,0,1,1.38-1.14h26a1,1,0,0,1,1,1.18l-.62,3.2A1.41,1.41,0,0,1,216.45,253.76Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 193.8,
    cy: 251,
    rx: 1.61,
    ry: 1.28,
    transform: "translate(-122.96 265.96) rotate(-55.03)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.23,251a1.84,1.84,0,0,1-1.66,1.51A1.16,1.16,0,0,1,196.5,251a1.85,1.85,0,0,1,1.66-1.51A1.15,1.15,0,0,1,199.23,251Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.3,251a1.85,1.85,0,0,1-1.66,1.51,1.16,1.16,0,0,1-1.08-1.51,1.86,1.86,0,0,1,1.67-1.51A1.16,1.16,0,0,1,203.3,251Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 206,
    cy: 251,
    rx: 1.61,
    ry: 1.28,
    transform: "translate(-117.75 275.95) rotate(-55.03)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.43,251a1.86,1.86,0,0,1-1.67,1.51,1.16,1.16,0,0,1-1.07-1.51,1.86,1.86,0,0,1,1.66-1.51A1.16,1.16,0,0,1,211.43,251Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 214.12,
    cy: 251,
    rx: 1.61,
    ry: 1.28,
    transform: "translate(-114.28 282.62) rotate(-55.03)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.08,254.26a1.12,1.12,0,0,1-.88-.41,1.14,1.14,0,0,1-.23-1l.79-4a1.49,1.49,0,0,1,1.42-1.18h4a1.12,1.12,0,0,1,.88.41,1.14,1.14,0,0,1,.23,1l-.79,4a1.49,1.49,0,0,1-1.42,1.18Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.08,253.76h4A1,1,0,0,0,225,253l.79-4a.62.62,0,0,0-.62-.78h-4a1,1,0,0,0-.93.78l-.79,4A.62.62,0,0,0,220.08,253.76Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.11,252.75a.2.2,0,0,1-.16-.07.27.27,0,0,1,.07-.36l1.59-1.32-1.06-1.32a.26.26,0,0,1,.07-.36.26.26,0,0,1,.35,0l1.2,1.5a.26.26,0,0,1-.07.36l-1.79,1.5A.31.31,0,0,1,222.11,252.75Z",
    style: {
      fill: "#007D87"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.91,251.25h-2.7a.2.2,0,0,1-.2-.25.32.32,0,0,1,.3-.25H224a.2.2,0,0,1,.2.25A.32.32,0,0,1,223.91,251.25Z",
    style: {
      fill: "#007D87"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-2"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 132.15,
    y: 160.39,
    width: 29.8,
    height: 29.8,
    rx: 4.12,
    transform: "translate(294.1 350.59) rotate(180)",
    style: {
      fill: "#007D87"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "144.72 189.08 147.05 199.1 149.38 189.08 144.72 189.08",
    style: {
      fill: "#007D87"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.79,184.23a17.69,17.69,0,0,1-8.62-14.54v-.32l8.87-3.78,8.86,3.78v.32a17.63,17.63,0,0,1-8.61,14.54l-.26.16Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.05,166.14l8.37,3.56a17,17,0,0,1-8.37,14.11Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.05,166.14l-8.38,3.56a17,17,0,0,0,8.38,14.11Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--group--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M139,279.11l7,1.05a26.09,26.09,0,0,1,4.88-1.05,32.94,32.94,0,0,1,5.4,0s3.17,1.19,3.17,4.22c0,0-7.39,2-10.22.79L139,283.33Z",
    style: {
      fill: "#e4897b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139,279.11l7,1.05a26.09,26.09,0,0,1,4.88-1.05,32.94,32.94,0,0,1,5.4,0s3.17,1.19,3.17,4.22c0,0-7.39,2-10.22.79L139,283.33Z",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.34,231.84a17.94,17.94,0,0,0,.84,4.23,2.33,2.33,0,0,1-2.44,0Z",
    style: {
      fill: "#aa473d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.07,229.84c-.27.65-.75,1.07-1.08.93s-.36-.76-.1-1.41.75-1.06,1.08-.93S159.33,229.2,159.07,229.84Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.71,227.6a.31.31,0,0,1-.18,0,4.12,4.12,0,0,0-3.55-.3.36.36,0,1,1-.33-.65,4.76,4.76,0,0,1,4.25.33.36.36,0,0,1,.12.5A.34.34,0,0,1,160.71,227.6Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.39,237.28c-.23.28-.46.55-.71.8a9.94,9.94,0,0,1-5.19,2.85,11.09,11.09,0,0,1-1.52.2,9.07,9.07,0,0,1-7.23-2.9,8.93,8.93,0,0,1-1.86-3.1c-1.79-4.8,0-8.58,2.59-15.23a9.76,9.76,0,0,1,16.26-3.31C161.91,222.05,158.43,232.08,154.39,237.28Z",
    style: {
      fill: "#e4897b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.49,240.93a11.09,11.09,0,0,1-1.52.2,9.07,9.07,0,0,1-7.23-2.9,10.68,10.68,0,0,1,2.15-1.67A14,14,0,0,1,148.49,240.93Z",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.93,241.18c.66,4.68,10.9,6.43,10.9,6.43s5,2.3,5.26.3c-2.09-2.42-2.32-4.53-1.6-6.38a9.1,9.1,0,0,1,2.06-3,17.76,17.76,0,0,1,1.49-1.38l-3.13-12.82C139.66,229.23,132,240.48,126.93,241.18Z",
    style: {
      fill: "#e4897b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.15,213s2.19-.27,3.87,3.81c1.41,3.43-1.92,4.18-1.77,7.83s-3.2,5.68-3.2,5.68-2.8,2.42-5.19,1.11c0,0-3.12,1.53-3.94,4.2s-5.65-2.15-10-1.42c0,0-2.94-2.75-2.72-9.43a23.08,23.08,0,0,1,2.1-8.38,11.38,11.38,0,0,1,6.24-6.2C146.51,207.94,155.22,209.62,156.15,213Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.26,229.42a4.6,4.6,0,0,0,.86,3.85c1.06,1.16,2.77-.31,3.46-2.34.6-1.81.81-4.64-.75-5S149.59,227.47,149.26,229.42Z",
    style: {
      fill: "#e4897b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.36,245.05q-2.15,6-3.84,11.5c-.72,2.28-1.38,4.51-2,6.66q-.76,2.71-1.42,5.26c-.21.82-.42,1.63-.62,2.43-1.1,4.41-2,8.43-2.69,12a158.65,158.65,0,0,0-2.59,16.87L98,294.83c1.36-6.74,2.42-12.63,3.9-19,.82-3.48,1.75-7.1,3-11.07.84-2.85,1.82-5.88,3-9.17,3.94-11.3,7.57-14.43,7.57-14.43C130.46,238.76,150.36,245.05,150.36,245.05Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.41,279.84l7,1.05a26.09,26.09,0,0,1,4.88-1.05,33.08,33.08,0,0,1,5.41,0s3.16,1.19,3.16,4.22c0,0-7.38,2-10.22.79l-10.22-.79Z",
    style: {
      fill: "#e4897b"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "120.08 409.11 127.39 409.24 131.03 392.39 123.73 392.26 120.08 409.11",
    style: {
      fill: "#ebb376"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "123.73 392.26 131.03 392.4 128.95 402.03 121.72 401.55 123.73 392.26",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.57,367.85a229.19,229.19,0,0,1-10.65,31.44l-13.33-1s5.47-21.37,7.45-40.95c1.23-12.08,1.12-22.08-2.42-22.85-2.22-.49-7.43-.48-14.11-.32V309.27c18.73,3.85,37.37,11.1,38.79,16.92C151.28,334.38,147.82,351.72,143.57,367.85Z",
    style: {
      fill: "#007D87"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "118.17 398.89 134.05 399.95 136.39 393.08 118.89 392.27 118.17 398.89",
    style: {
      fill: "#007D87"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "118.17 398.89 134.05 399.95 136.39 393.08 118.89 392.27 118.17 398.89",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.49,408.88l.15,0s.17.05.19.07,0,0,0,0h.06a8.89,8.89,0,0,0,1.9.38,1.93,1.93,0,0,0,1.39-.27.9.9,0,0,0,.27-.94.68.68,0,0,0-.37-.51,3,3,0,0,0-2,.38,2.64,2.64,0,0,0,.72-1.67.7.7,0,0,0-.62-.56,1.13,1.13,0,0,0-.81.19c-.77.66-.89,2.73-.89,2.85h0Zm.79-.42-.15.08a3.6,3.6,0,0,1,.61-2.23.48.48,0,0,1,.37-.14l.09,0c.24,0,.29.16.3.26A3.45,3.45,0,0,1,129.28,408.46Zm.1.36c.88-.49,2.13-1,2.6-.81a.32.32,0,0,1,.17.25.61.61,0,0,1-.16.6C131.63,409.18,130.67,409.16,129.38,408.82Z",
    style: {
      fill: "#007D87"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.32,408l-8.19-.51a.52.52,0,0,0-.57.46h0l-.8,6.45a1.29,1.29,0,0,0,1.19,1.37c2.86.13,4.23.05,7.83.25a67.52,67.52,0,0,0,9.62.3c3-.29,2.67-3.3,1.36-3.44-3.13-.36-7.26-2.65-9.22-4.39A2,2,0,0,0,128.32,408Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.57,367.85c-5-3.15-10.81-6.86-16.53-10.53,1.23-12.08,1.12-22.08-2.42-22.85-2.22-.49-7.43-.48-14.11-.32V309.27c18.73,3.85,37.37,11.1,38.79,16.92C151.28,334.38,147.82,351.72,143.57,367.85Z",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "162.81 409.11 170.12 409.24 173.76 392.39 166.46 392.26 162.81 409.11",
    style: {
      fill: "#ebb376"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "166.46 392.26 173.76 392.4 171.68 402.03 164.45 401.55 166.46 392.26",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.27,306.83l1.18-9.44L99.28,291.1S86.79,315.84,92.9,328c5.61,11.12,65.27,4.49,74.45,6.5s-5,63.81-5,63.81l13.34,1s20.6-55.6,16.37-73.09C190.18,318.57,158.73,308.46,136.27,306.83Z",
    style: {
      fill: "#007D87"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "160.9 398.89 176.78 399.95 179.12 393.08 161.62 392.27 160.9 398.89",
    style: {
      fill: "#007D87"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "160.9 398.89 176.78 399.95 179.12 393.08 161.62 392.27 160.9 398.89",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.22,408.88l.15,0s.17.05.19.07,0,0,0,0h.06a8.89,8.89,0,0,0,1.9.38,1.93,1.93,0,0,0,1.39-.27.9.9,0,0,0,.27-.94.68.68,0,0,0-.37-.51,3,3,0,0,0-2,.38,2.64,2.64,0,0,0,.72-1.67.7.7,0,0,0-.62-.56,1.13,1.13,0,0,0-.81.19c-.77.66-.89,2.73-.89,2.85h0Zm.79-.42-.15.08a3.6,3.6,0,0,1,.61-2.23.48.48,0,0,1,.37-.14l.09,0c.24,0,.29.16.3.26A3.4,3.4,0,0,1,172,408.46Zm.1.36c.88-.49,2.13-1,2.6-.81a.32.32,0,0,1,.17.25.61.61,0,0,1-.16.6C174.36,409.18,173.4,409.16,172.11,408.82Z",
    style: {
      fill: "#007D87"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.05,408l-8.19-.51a.52.52,0,0,0-.57.46h0l-.8,6.45a1.29,1.29,0,0,0,1.19,1.37c2.86.13,4.23.05,7.83.25a67.52,67.52,0,0,0,9.62.3c3.05-.29,2.68-3.3,1.36-3.44-3.13-.36-7.26-2.65-9.22-4.39A2,2,0,0,0,171.05,408Z",
    style: {
      fill: "#263238"
    }
  }), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "97.88 295.4 115.56 297.72 116.14 295.11 98.42 292.53 97.88 295.4"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "117.61 295.13 117.39 297.72 133.74 299.97 133.74 297.4 117.61 295.13"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "134.75 297.55 134.75 299.97 137.13 300.28 137.13 297.94 134.75 297.55"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M146.52,256.55c-.72,2.28-1.38,4.51-2,6.66q-.76,2.71-1.42,5.26c-1.23-6.7,1-14.7,1-14.7Z",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.36,245c3.19.65,4.24,25.44,4.38,28.08s15.66,7.77,15.66,7.77v3.61s-16.64-1.16-20.53-2.75S145,257.16,145,257.16Z",
    style: {
      fill: "#e4897b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.36,245c2.93.91,4.38,17.26,4.38,17.26L145.68,266l-2.25-9.09s-.64-1.85.62-5.75C145.88,245.47,150.36,245,150.36,245Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M82.78,326.52H155a7.91,7.91,0,0,1,7.91,7.91v4.23a0,0,0,0,1,0,0H74.87a0,0,0,0,1,0,0v-4.23a7.91,7.91,0,0,1,7.91-7.91Z",
    style: {
      fill: "#007D87"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.27,296.45h48.49a3.88,3.88,0,0,1,3.78,4.76l-8.67,37.45h-2l7.38-32.82a3.87,3.87,0,0,0-3.78-4.73H107.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.63,340v31.65a1.84,1.84,0,0,1-1.84,1.84H115a1.84,1.84,0,0,1-1.84-1.84V340Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.79,413.06a3.36,3.36,0,1,0-3.36,3.36A3.36,3.36,0,0,0,81.79,413.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.11,413.06a1.68,1.68,0,1,0-1.68,1.68A1.69,1.69,0,0,0,80.11,413.06Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.74,413.06a3.37,3.37,0,1,0-3.36,3.36A3.37,3.37,0,0,0,162.74,413.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.06,413.06a1.68,1.68,0,1,0-1.68,1.68A1.69,1.69,0,0,0,161.06,413.06Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.68,398.3V362.12h-5.56V398.3c-21.66.56-34.83,8.13-37.46,9.79a1,1,0,0,0-.49.9v3a1.06,1.06,0,0,0,1.06,1.07h0a1.07,1.07,0,0,0,.92-.54l1.29-2.26a121.92,121.92,0,0,1,34.68-5.74v6a1.37,1.37,0,0,0,1.38,1.37h2.81a1.37,1.37,0,0,0,1.37-1.37v-6a121.94,121.94,0,0,1,34.69,5.74l1.28,2.26a1.07,1.07,0,0,0,.93.54h0a1.07,1.07,0,0,0,1.06-1.07v-3a1,1,0,0,0-.49-.9C156.51,406.43,143.35,398.86,121.68,398.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 117.08,
    y: 409.69,
    width: 3.65,
    height: 6.73,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 113.19,
    y: 339.97,
    width: 11.44,
    height: 13.15,
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.35,336.71v3.78a1.93,1.93,0,0,1-1.94,1.93h-89a1.92,1.92,0,0,1-1.93-1.93v-3.78a1.93,1.93,0,0,1,1.93-1.93h89A1.94,1.94,0,0,1,165.35,336.71Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.4,338.66H72.47S56,311.22,56,265.88V249.23a12.4,12.4,0,0,1,12.4-12.39h22a12.39,12.39,0,0,1,12.39,12C103.42,272.24,106.86,322.83,124.4,338.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113,338.66H74.81a3.92,3.92,0,0,1-3.5-2.12C67.55,329.3,56,303.87,56,265.88V249.23a12.39,12.39,0,0,1,12.39-12.39h19a12.39,12.39,0,0,1,12.39,12c.57,20.87,3.37,63.48,16.47,83.61A4,4,0,0,1,113,338.66Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.35,336.71v3.78a1.93,1.93,0,0,1-1.93,1.93H123.53a2.6,2.6,0,0,1-2.61-2.6v-2.43a2.61,2.61,0,0,1,2.61-2.61h39.88A1.94,1.94,0,0,1,165.35,336.71Z",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.45,235.37l3.3-4.32s14.09.64,14.43,5.79S72.45,235.37,72.45,235.37Z",
    style: {
      fill: "#007D87"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.19,248.3s.86,22.9,0,82c0,2-7.46,1.92-8,0-1.79-6.73,0-60.47,0-60.47",
    style: {
      fill: "#007D87"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "55.36 330.6 62.95 330.86 62.95 334.65 55.36 334.26 55.36 330.6",
    style: {
      fill: "#007D87"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.19,248.3s.86,22.9,0,82c0,2-7.46,1.92-8,0-1.79-6.73,0-60.47,0-60.47",
    style: {
      fill: "#fff",
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.61,318.22c-.41-10.9-1.9-61,4.36-77.6,0,0,5.89-7.48,25.82-7.48s25.93,14.15,25.93,14.15.86,22.89,0,82c0,2-7.46,1.93-8,0-1.79-6.72,0-60.47,0-60.47l-4,48.9a1.21,1.21,0,0,1-1.38,1.09c-6.29-1-34-4.89-41.33.11A.91.91,0,0,1,51.61,318.22Z",
    style: {
      fill: "#007D87"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "99.89 329.59 107.48 329.85 107.48 333.64 99.89 333.25 99.89 329.59",
    style: {
      fill: "#007D87"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.75,318.86l-.6,4s-30.93-6.74-40.95.44l-.6-4.43S60.34,311.73,94.75,318.86Z",
    style: {
      fill: "#007D87"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.61,318.22c-.41-10.9-1.9-61,4.36-77.6,0,0,5.89-7.48,25.82-7.48s25.93,14.15,25.93,14.15.86,22.89,0,82c0,2-7.46,1.93-8,0-1.79-6.72,0-60.47,0-60.47l-4,48.9a1.21,1.21,0,0,1-1.38,1.09c-6.29-1-34-4.89-41.33.11A.91.91,0,0,1,51.61,318.22Z",
    style: {
      fill: "#fff",
      opacity: 0.4,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.75,268.82s.44-15.52,8-21.53C107.72,247.29,98.3,251.34,99.75,268.82Z",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.07,234.93s-9.1,5-10.55,73.13C66.52,308.06,62.56,239.33,77.07,234.93Z",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVectorLogout);
export default __webpack_public_path__ + "static/media/vectorLogout.e7d4409e3cae244a1929d90d6edbc3c0.svg";
export { ForwardRef as ReactComponent };